import { mapMutations } from "vuex";
import store from "../store";

const Progress = {
    show(value) {   
        store.commit('progress',value);
    },
};

export const ProgressPlugin = {
    install(Vue) {
        Vue.prototype.$progress = Progress
    }
}

export default Progress
